/// <amd-module name="SuiteCommerce.SizeChart.Common.Configuration"/>
define("SuiteCommerce.SizeChart.Common.Configuration", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Configuration = void 0;
    var environment = null;
    var Configuration = /** @class */ (function () {
        function Configuration() {
        }
        Object.defineProperty(Configuration, "environment", {
            set: function (environmentComponent) {
                environment = environmentComponent;
            },
            enumerable: false,
            configurable: true
        });
        Configuration.get = function (key) {
            if (environment) {
                return environment.getConfig(key);
            }
            console.error('Please set the Environment Component in the Configuration.');
            return null;
        };
        Object.defineProperty(Configuration, "sizeChartPageURL", {
            get: function () {
                return 'size-charts';
            },
            enumerable: false,
            configurable: true
        });
        return Configuration;
    }());
    exports.Configuration = Configuration;
});
